import { render, staticRenderFns } from "./LastOrders.vue?vue&type=template&id=4ff3cfad&scoped=true"
import script from "./LastOrders.vue?vue&type=script&lang=js"
export * from "./LastOrders.vue?vue&type=script&lang=js"
import style0 from "./LastOrders.vue?vue&type=style&index=0&id=4ff3cfad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3cfad",
  null
  
)

export default component.exports